import { render, staticRenderFns } from "./UserAccountModal.vue?vue&type=template&id=2595bc24&scoped=true&"
import script from "./UserAccountModal.vue?vue&type=script&lang=js&"
export * from "./UserAccountModal.vue?vue&type=script&lang=js&"
import style0 from "./UserAccountModal.vue?vue&type=style&index=0&id=2595bc24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2595bc24",
  null
  
)

export default component.exports